module.exports = __webpack_public_path__ + "img/angle.88b38745.png";